const envFlag = process.env.REACT_APP_ENABLE_AI;

export const AI_FEATURES_ENABLED =
  envFlag === 'true' ||
  (envFlag !== 'false' && process.env.NODE_ENV !== 'production');
